import {definePerfDuration, definePerfSingleMark} from '../addPerfMark';

export type SearchInputSource = 'clear' | 'history_item' | 'typing';

type PanelBankSearchMarkNames = Readonly<{
  changed: 'panel_bank_search_changed';
  settled: 'panel_bank_search_settled';
  superseded: 'panel_bank_search_superseded';
}>;

const panelBankSearchMarks: PanelBankSearchMarkNames = {
  // startEvent - clear, history item, or typing before debounce
  changed: 'panel_bank_search_changed',
  // endEvent - PanelBankSections rendered the matching query, then afterFrame
  settled: 'panel_bank_search_settled',
  // Explains dropped durations when newer input wins
  superseded: 'panel_bank_search_superseded',
} as const;

type PanelSearchSingleMarkContract = ReturnType<typeof definePerfSingleMark> & {
  tooltipText: string;
};

export const panelBankSearchInputMarkBySource: Record<
  SearchInputSource,
  PanelSearchSingleMarkContract
> = {
  clear: {
    ...definePerfSingleMark({
      actionName: 'panel_bank_search_cleared',
      markName: 'panel_bank_search_cleared',
    }),
    tooltipText: 'Panel search cleared',
  },
  history_item: {
    ...definePerfSingleMark({
      actionName: 'panel_bank_search_history_item_selected',
      markName: 'panel_bank_search_history_item_selected',
    }),
    tooltipText: 'Panel search history item selected',
  },
  typing: {
    ...definePerfSingleMark({
      actionName: 'panel_bank_search_keypressed',
      markName: 'panel_bank_search_keypressed',
    }),
    tooltipText: 'Panel search typing registered',
  },
};

export const panelBankSearchSupersededMark: PanelSearchSingleMarkContract = {
  ...definePerfSingleMark({
    actionName: panelBankSearchMarks.superseded,
    markName: panelBankSearchMarks.superseded,
  }),
  tooltipText: 'Panel search query superseded before results settled',
};

// Measures input change to PanelBankSections paint for the matching query
// startEvent - clear, history item, or typing before debounce
// endEvent - PanelBankSections rendered the matching query, then afterFrame
export const panelBankSearchDataSettledDuration = definePerfDuration({
  durationName: 'panel_bank_search_data_settled',
  startMark: panelBankSearchMarks.changed,
  endMark: panelBankSearchMarks.settled,
  description: 'panel search input to matching PanelBankSections paint',
  owner: 'workspace',
  maxPairingDurationMs: 30_000, // arbitrary chosen -  prevents abandoned starts from pairing with much later searches
  devtools: {
    track: 'Panel search',
    trackGroup: 'Workspace',
    color: 'primary',
  },
});
